module.exports = __webpack_public_path__ + "img/logo_light.14202fb7.svg";